<div class="info">
  <div class="container">
    <div class="row mx-0">
      <div class="tags">
        <div class="tag grey noHover">Hunt Package</div>
      </div>
      <h1>{{ data?.title }}</h1>
      <i
        *ngIf="favorited"
        class="k-icon k-font-icon k-i-bookmark favorite k-color-primary"
        (click)="unfavorite()"
      ></i>
      <i
        *ngIf="!favorited"
        class="k-icon k-font-icon k-i-bookmark-outline favorite k-color-primary"
        (click)="favorite()"
      ></i>
      <div class="options">
        <button
          themeColor="primary"
          icon="comment"
          (click)="onFeedback()"
          kendoButton
        >
          Feedback
        </button>
      </div>
    </div>
    <ng-container *ngIf="locked$ | async">
      <ng-container *ngIf="relatedCollections$ | async as collections">
        <div
          *ngIf="collections.length > 0"
          class="row premium-ad"
          (click)="openPremiumDialog()"
        >
          <img
            width="16"
            height="16"
            src="/assets/img/icons/cyborg-premium.png"
          />
          <p>
            Access all hunt packages in the
            {{ collections[0].title }} collection
            <span *ngIf="collections.length > 1"
              >and {{ collections.length - 1 }} more collections
            </span>
            with Hunter Premium
          </p>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
<main>
  <ng-template #notShow>
    <p>--</p>
  </ng-template>
  <div class="container">
    <div class="row">
      <aside class="col-lg-2 px-0 left">
        <ul>
          <li *ngIf="environments && environments?.length > 0">
            <a (click)="scrollTo('environment-content')">My Environment</a>
          </li>
          <li *ngIf="huntContent.length > 0">
            <a (click)="scrollTo('hunt-content')">Hunt Queries</a>
          </li>
          <li *ngIf="detectionContent.length > 0">
            <a (click)="scrollTo('detection-content')">Detection Rules</a>
          </li>
          <li><a (click)="scrollTo('overview')">Overview</a></li>
          <li>
            <ul class="sub">
              <li>Description</li>
            </ul>
          </li>
          <li *ngIf="data?.validation">
            <a (click)="scrollTo('emulationAndValidation')"
              >Emulation and Validation</a
            >
          </li>
          <li *ngIf="queryLogicData?.length > 0">
            <a (click)="scrollTo('queryLogic')">Query Logic</a>
          </li>
          <li><a (click)="scrollTo('research')">Research</a></li>
          <li>
            <ul class="sub">
              <li>Analyst Notes</li>
              <li>Threat Description</li>
            </ul>
          </li>
          <li><a (click)="scrollTo('references')">References</a></li>
          <li><a (click)="scrollTo('mitre')">MITRE Information</a></li>
          <li><a (click)="scrollTo('response')">Response Actions</a></li>
          <li>
            <ul class="sub">
              <li>Analyst Runbook</li>
              <li>Mitigation Recommendation</li>
            </ul>
          </li>
        </ul>
      </aside>
      <div class="col-lg-10 px-0">
        <cyborg-section
          *ngIf="environments && environments?.length > 0"
          [ngClass]="{ 'is-closed': isEnvContentClosed }"
          id="environment-content"
        >
          <cyborg-section-title>
            <div class="logo">
              <span>My Environment</span>
            </div>
            <i
              class="k-icon k-font-icon k-i-arrow-chevron-down"
              (click)="onEnvContentClose()"
            ></i>
          </cyborg-section-title>

          <div class="row">
            <div class="col-12 env-filters">
              <form [formGroup]="contentForm">
                <div style="display: flex" class="row">
                  <div class="col-3">
                    <kendo-formfield>
                      <label for="environments">Environments</label>
                      <kendo-multiselect
                        [data]="environments"
                        textField="name"
                        valueField="id"
                        placeholder="Environments"
                        formControlName="environments"
                        [valuePrimitive]="true"
                        (valueChange)="filterContent()"
                      >
                      </kendo-multiselect>
                    </kendo-formfield>
                  </div>
                  <div class="col-3">
                    <kendo-formfield>
                      <label for="tools">Tools</label>
                      <kendo-multiselect
                        [data]="tools"
                        formControlName="tools"
                        placeholder="Tools"
                        (valueChange)="filterContent()"
                      ></kendo-multiselect>
                    </kendo-formfield>
                  </div>
                  <div class="col-3">
                    <kendo-formfield>
                      <label for="categories">Categories</label>
                      <kendo-multiselect
                        [data]="categories"
                        placeholder="Categories"
                        formControlName="categories"
                        (valueChange)="filterContent()"
                      ></kendo-multiselect>
                    </kendo-formfield>
                  </div>
                  <div class="col-2">
                    <span class="clear link" (click)="clearAllFilters()">
                      Clear all filters
                    </span>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="row">
            <p
              class="no-envs"
              *ngIf="environmentContent && environmentContent?.length == 0"
            >
              No environment content to display. Update your environment
              configuration
              <a class="link" routerLink="/settings/environment">here</a>.
            </p>
            <cyborg-environment-content
              *ngFor="let environment of environmentContent"
              [environment]="environment"
            >
            </cyborg-environment-content>
          </div>
        </cyborg-section>
        <cyborg-section
          *ngIf="huntContent.length > 0"
          [ngClass]="{ 'is-closed': isHuntContentClosed }"
          id="hunt-content"
        >
          <cyborg-section-title>
            <div class="logo">
              <span>Hunt Queries</span>
            </div>
            <div>
              <span *ngIf="huntCompatible">
                <span *ngIf="huntModuleAccess; else noAccess">
                  <kendo-dropdownbutton
                    themeColor="primary"
                    [data]="options"
                    textField="actionName"
                    icon="chevron-down"
                  >
                    Hunt
                  </kendo-dropdownbutton>
                </span>
              </span>
              <ng-template #noAccess>
                <cyborg-button
                  color="outline"
                  size="medium"
                  (click)="openHuntDialog()"
                >
                  <img
                    style="margin-right: 5px"
                    width="16"
                    height="16"
                    src="/assets/img/icons/cyborg-premium.png"
                  />
                  Hunt
                </cyborg-button>
              </ng-template>
              <i
                class="k-icon k-font-icon k-i-arrow-chevron-down"
                (click)="onHuntContentClose()"
              ></i>
            </div>
          </cyborg-section-title>
          <div class="row">
            <cyborg-content
              *ngFor="let content of huntContent"
              [content]="content"
              [huntPackage]="data"
              type="hunt-package"
            >
            </cyborg-content>
          </div>
        </cyborg-section>
        <cyborg-section
          *ngIf="detectionContent.length > 0"
          [ngClass]="{ 'is-closed': isDetectionContentClosed }"
          id="detection-content"
        >
          <cyborg-section-title>
            <div class="logo">
              <span>Detection Rules</span>
            </div>
            <div>
              <ng-template
                [ngIf]="deployStatus && deployStatus === 'notDeployed'"
              >
                <button
                  class="mx-3"
                  themeColor="primary"
                  (click)="markAsStaged(huntPackageUUID)"
                  kendoButton
                >
                  Stage for Deploy
                </button>
                <button
                  themeColor="primary"
                  (click)="markAsDeployed(huntPackageUUID)"
                  kendoButton
                >
                  Mark as Deployed
                </button>
              </ng-template>
              <ng-template [ngIf]="deployStatus && deployStatus === 'staged'">
                <button
                  class="mx-3"
                  themeColor="primary"
                  fillMode="outline"
                  (click)="removeDeployed(huntPackageUUID)"
                  kendoButton
                >
                  Unstage
                </button>
                <button
                  themeColor="primary"
                  (click)="markAsDeployed(huntPackageUUID)"
                  kendoButton
                >
                  Mark as Deployed
                </button>
              </ng-template>
              <ng-template [ngIf]="deployStatus && deployStatus === 'deployed'">
                <button
                  class="mx-3"
                  themeColor="primary"
                  fillMode="outline"
                  (click)="removeDeployed(huntPackageUUID)"
                  kendoButton
                >
                  Remove From Deployed
                </button>
              </ng-template>
              <ng-template [ngIf]="deployStatus && deployStatus === 'outdated'">
                <button
                  themeColor="primary"
                  (click)="markAsDeployed(huntPackageUUID)"
                  kendoButton
                >
                  Re-Deploy
                </button>
              </ng-template>
              <i
                class="k-icon k-font-icon k-i-arrow-chevron-down"
                (click)="onDetectionContentClose()"
              ></i>
            </div>
          </cyborg-section-title>
          <div class="row">
            <cyborg-content
              *ngFor="let content of detectionContent"
              [content]="content"
              [huntPackage]="data"
              type="hunt-package"
            >
            </cyborg-content>
          </div>
        </cyborg-section>
        <cyborg-section
          *ngIf="
            (relatedHunts$ | async)?.length > 0 &&
            (relatedHunts$ | async) as related
          "
          id="related-hunts"
        >
          <cyborg-section-title>
            <div class="logo">
              <span>Related Hunts</span>
            </div>
          </cyborg-section-title>
          <div class="related-wrapper">
            <div
              class="py-3 related-hunts"
              *ngFor="let hunt of showAll ? related : related.slice(0, 5)"
            >
              <a class="link" routerLink="/hunt/{{ hunt.id }}">{{
                hunt.name
              }}</a>
              <div class="badges">
                <span
                  class="badge lg"
                  [class.badge-success]="hunt.priority === priority.LOW"
                  [class.badge-warning]="hunt.priority === priority.MEDIUM"
                  [class.badge-danger]="hunt.priority === priority.HIGH"
                  >{{ hunt.priority }}</span
                >
                <span
                  class="badge lg"
                  [class.badge-info]="hunt.status === status.TO_DO"
                  [class.badge-warning]="hunt.status === status.IN_PROGRESS"
                  [class.badge-success]="hunt.status === status.DONE"
                  >{{ hunt.status }}</span
                >
                <span
                  *ngIf="hunt.outcome"
                  class="badge lg"
                  [class.badge-info]="hunt.outcome === outcome.VISIBILITY_GAP"
                  [class.badge-success]="hunt.outcome === outcome.NO_FINDINGS"
                  [class.badge-warning]="hunt.outcome === outcome.DETECTION"
                  [class.badge-danger]="hunt.outcome === outcome.ESCALATED"
                  >{{ hunt.outcome }}</span
                >
              </div>
            </div>
          </div>
          <a class="pt-5 show link" (click)="toggleShowAll()"
            >Show <span *ngIf="!showAll">more</span
            ><span *ngIf="showAll">less</span>...</a
          >
        </cyborg-section>
        <cyborg-section id="overview">
          <cyborg-section-title>
            <div class="logo">
              <span>Overview</span>
            </div>
          </cyborg-section-title>
          <div *ngIf="deepDive" class="deep-dive">
            <iframe
              [src]="deepDive"
              width="560"
              height="315"
              frameborder="0"
              webkitallowfullscreen
              mozallowfullscreen
              allowfullscreen
            ></iframe>
          </div>
          <cyborg-hunt-package-overview
            [data]="data"
          ></cyborg-hunt-package-overview>
        </cyborg-section>
        <cyborg-section id="emulationAndValidation">
          <cyborg-section-title>
            <div class="logo">
              <span>Emulation and Validation</span>
            </div>
          </cyborg-section-title>
          <cyborg-content-section>
            <pre>{{ data?.validation }}</pre>
            <div class="row justify-content-center">
              <button
                icon="export"
                *ngIf="
                  data?.validation_types &&
                  data?.validation_types.length > 0 &&
                  !data?.validation_types.includes('manual')
                "
                themeColor="primary"
                size="medium"
                (click)="downloadValidation(data?.title)"
                kendoButton
              >
                Download Validation Package
              </button>
            </div>
          </cyborg-content-section>
        </cyborg-section>
        <cyborg-section id="queryLogic">
          <cyborg-section-title>
            <div class="logo">
              <div>
                <span>Query Logic</span>
                <span [tooltipWidth]="400" kendoTooltip filter="i" id="tooltip">
                  <i
                    href="#"
                    class="k-icon k-font-icon k-i-info"
                    title="This table exists as a tool agnostic language to inform analysts of how a query should work for your specific system. If you use one of the supported tools, it is recommended you use the available queries provided in the package.&#13;Each selection in the table below represents an indicator or element of identifying suspicious or malicious acitivty in scope of the package. Some elements may be negated to indicate exceptions or filter known good activity. Not all selections may be necessary, and provided boolean logic will apply to create an effective combination.&#13;The final line of the table represents boolean logic and how each selection should be combined to produce a query."
                  ></i>
                </span>
              </div>
            </div>
          </cyborg-section-title>
          <cyborg-query-logic
            [queryLogic]="data?.query_logic"
          ></cyborg-query-logic>
        </cyborg-section>
        <cyborg-section id="research">
          <cyborg-section-title>
            <div class="logo">
              <span>Research</span>
            </div>
          </cyborg-section-title>
          <div class="row justify-content-center">
            <div class="col-11">
              <div class="row details">
                <div class="col-12">
                  <span>Analyst Notes</span>
                  <cyborg-markdown
                    *ngIf="data?.analyst_notes; else notShow"
                    [md]="data?.analyst_notes"
                  ></cyborg-markdown>
                </div>
                <div class="col-12">
                  <span>Threat Description</span>
                  <cyborg-markdown
                    *ngIf="data?.context.threat_description; else notShow"
                    [md]="data?.context.threat_description"
                  ></cyborg-markdown>
                </div>
              </div>
            </div>
          </div>
        </cyborg-section>

        <cyborg-section id="references">
          <cyborg-section-title>
            <div class="logo">
              <span>References</span>
            </div>
          </cyborg-section-title>
          <div class="row justify-content-center">
            <div class="col-11">
              <div class="row details">
                <div class="col-6">
                  <span>General</span>
                  <p *ngIf="data?.references.general?.length > 0; else notShow">
                    {{ data?.references.general?.join(', ') }}
                  </p>
                </div>
                <div class="col-6">
                  <span>Analysis</span>
                  <p *ngIf="data?.references.analysis.length > 0; else notShow">
                    {{ data?.references.analysis.join(', ') }}
                  </p>
                </div>
                <div class="col-6">
                  <span>Blog Links</span>
                  <p
                    *ngIf="data?.references.blog_links.length > 0; else notShow"
                  >
                    {{ data?.references.blog_links.join(', ') }}
                  </p>
                </div>
                <div class="col-6">
                  <span>Malware Samples</span>
                  <p
                    *ngIf="
                      data?.references.malware_samples.length > 0;
                      else notShow
                    "
                  >
                    {{ data?.references.malware_samples.join(', ') }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </cyborg-section>

        <cyborg-section
          *ngIf="data?.mapping?.mitre?.mitre_attack_tactics.length > 0"
          id="mitre"
        >
          <cyborg-section-title>
            <div class="logo">
              <span>MITRE Information</span>
            </div>
          </cyborg-section-title>
          <div class="row justify-content-center">
            <div class="col-11">
              <div class="row details">
                <div class="col-4">
                  <span>Tactic</span>
                  <p>
                    <td>
                      {{
                        data?.mapping?.mitre?.mitre_attack_tactics.join(', ')
                      }}
                    </td>
                  </p>
                </div>
                <div class="col-4">
                  <span>Technique</span>
                  <p>
                    <td>
                      {{
                        data?.mapping?.mitre?.mitre_attack_techniques.join(', ')
                      }}
                    </td>
                  </p>
                </div>
                <div class="col-4">
                  <span>Technique ID</span>
                  <p>
                    <td>
                      <span
                        *ngFor="
                          let id of data?.mapping?.mitre
                            ?.mitre_attack_technique_ids;
                          last as isLast
                        "
                        ><a
                          class="link"
                          href="https://attack.mitre.org/techniques/{{
                            id.replace('.', '/')
                          }}"
                          target="_blank"
                          >{{ id }}</a
                        ><span *ngIf="!isLast">, &nbsp;</span></span
                      >
                    </td>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </cyborg-section>
        <cyborg-section id="response">
          <cyborg-section-title>
            <div class="logo">
              <span>Response Actions</span>
            </div>
          </cyborg-section-title>

          <div class="row justify-content-center">
            <div class="col-11">
              <div class="row details">
                <div class="col-12">
                  <span>Analyst Runbook</span>
                  <cyborg-markdown
                    *ngIf="data?.response_actions.analyst_runbook; else notShow"
                    [md]="data?.response_actions.analyst_runbook"
                  ></cyborg-markdown>
                </div>

                <div class="col-12">
                  <span>Mitigation Recommendations</span>
                  <cyborg-markdown
                    *ngIf="
                      data?.response_actions.mitigation_recommendations;
                      else notShow
                    "
                    [md]="data?.response_actions.mitigation_recommendations"
                  ></cyborg-markdown>
                </div>
                <div class="col-12" *ngIf="data?.response_actions.playbook">
                  <span>Playbook</span>
                  <p>{{ data?.response_actions.playbook }}</p>
                </div>
              </div>
            </div>
          </div>
        </cyborg-section>
      </div>
    </div>
  </div>
</main>
<cyborg-modal-feedback
  id="feedback"
  class="modal"
  [huntPackageUUID]="huntPackageUUID"
></cyborg-modal-feedback>
<div kendoDialogContainer></div>
